// Maps raw better-auth error query params to user-friendly copy.
//
// Better-auth's /api/auth/error route redirects to the configured
// errorURL with the failure message in `?error=`, encoded with `_`
// for spaces and `%`-escapes for everything else. The mapping picks
// the most common cases and falls back to the decoded raw string for
// anything we haven't handled yet — better to leak a slightly clunky
// message than to silently swallow it.

export function humanizeAuthError(raw: string): string {
	const decoded = decode(raw);
	const lower = decoded.toLowerCase();

	if (lower.includes("isn't invited") || lower.includes("not invited")) {
		return "This email isn't invited. Ask an admin to invite you, then try again.";
	}
	if (
		lower.includes("code verification") ||
		lower.includes("invalid client")
	) {
		return "Sign-in handshake failed. Try again; if it keeps happening, contact support.";
	}
	if (lower.includes("access denied")) {
		return "You declined the sign-in on the provider's page.";
	}
	if (lower.includes("session expired") || lower.includes("not authenticated")) {
		return "Your session expired. Sign in again.";
	}
	if (lower.includes("oauth")) {
		return "Sign-in didn't complete. Try again, or pick a different provider.";
	}
	return decoded;
}

function decode(raw: string): string {
	// Better-auth substitutes `_` for spaces in the error param, then
	// percent-encodes the rest. decodeURIComponent only undoes the
	// percent layer — we have to undo the underscores ourselves.
	try {
		return decodeURIComponent(raw).replace(/_/g, " ");
	} catch {
		return raw.replace(/_/g, " ");
	}
}
